if (!customElements.get('countdown-bar')) {
  customElements.define(
    'countdown-bar',
    class CountdownBar extends HTMLElement {
      constructor() {
        super();
        this.intervalId = null;
      }

      connectedCallback() {
        this.endDate = this.dataset.endDate;
        this.hideWhenComplete = this.dataset.hideWhenComplete === 'true';
        this.daysEl = this.querySelector('[data-countdown-days]');
        this.hoursEl = this.querySelector('[data-countdown-hours]');
        this.minutesEl = this.querySelector('[data-countdown-minutes]');
        this.secondsEl = this.querySelector('[data-countdown-seconds]');

        const endTime = Date.parse(this.endDate);
        if (Number.isNaN(endTime)) {
          if (this.hideWhenComplete) this.hidden = true;
          return;
        }

        this.endTime = endTime;
        this.tick();
        this.intervalId = window.setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) window.clearInterval(this.intervalId);
      }

      tick() {
        const remaining = this.endTime - Date.now();

        if (remaining <= 0) {
          this.updateDisplay(0, 0, 0, 0);
          if (this.intervalId) window.clearInterval(this.intervalId);
          if (this.hideWhenComplete) {
            this.hidden = true;
            this.dispatchEvent(new CustomEvent('countdown-bar:complete', { bubbles: true }));
          }
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        this.updateDisplay(days, hours, minutes, seconds);
      }

      updateDisplay(days, hours, minutes, seconds) {
        if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
